
import { COLLECT_INIT_WIDTH, COLLECT_EXPEND_WIDTH } from "./const.js"
import slotWidget from "./slot-widget"
import freeGiftDrawer from "./free-gift-drawer"

export default {
  components: {
    slotWidget,
    freeGiftDrawer
  },
  props: {
    coreData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      drawerSize: COLLECT_INIT_WIDTH
    }
  },
  computed: {},
  watch: {},
  methods: {
    handleOpen() {
      this.$refs.freeGiftDrawer.open()
    }
  }
}
